/**
 * Akce fáze — tlačítko na spodku stálého pruhu (`StalyPruh`, prop `akce`).
 *
 * Návrh „Horní panel směny" (2026-10-12): plné tlačítko 56 px se zaoblením
 * jako tlačítka cockpitu a karty dávky, bez lesku a přechodu. Výška je ve
 * všech fázích stejná, takže panel nad prací neposkakuje.
 *
 *   plné   — barva fáze (zahájení oranžová, ukončení zelená), tmavé písmo.
 *            „Teď můžeš dál."
 *   tiché  — `tichy`: obrysové, bez výplně. Během průběhu je „Ukončit
 *            směnu" věc, která se ťuká jednou za den — hlavní akce je
 *            v práci pod panelem (karta dávky), tak ať s ní nesoupeří.
 *   ztlumené (nesplněný checklist, busy) — šedé, nedá se stisknout; text
 *            říká, co chybí („Zbývá 2 kontroly").
 *
 * S `secondary` → **dělené tlačítko**: hlavní akce a vedlejší cesta
 * („Jiný čas" / „Zrušit") za tenkou linkou. Pořád jedna volba.
 */
export default function ShiftCardCta({
    label,
    icon,
    onClick,
    disabled = false,
    busy = false,
    busyLabel,
    barva = '#10B981',         // barva fáze
    tichy = false,             // obrysové — akce, která nemá soupeřit s prací
    secondary = null,          // { icon, label, onClick, title } | null
}) {
    const muted = disabled || busy;
    const cursor = busy ? 'wait' : (disabled ? 'not-allowed' : 'pointer');

    const vzhled = muted
        ? { background: 'var(--surface-elevated)', color: 'var(--text-muted)', border: '1px solid var(--border-default)' }
        : tichy
            ? { background: 'transparent', color: 'var(--text-secondary)', border: '1px solid var(--border-strong)' }
            : { background: barva, color: '#0A0A0C', border: `1px solid ${barva}` };

    const text = {
        fontWeight: 800,
        whiteSpace: 'nowrap', overflow: 'hidden',
        border: 'none', background: 'none', color: 'inherit', cursor,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minWidth: 0, font: 'inherit', WebkitTapHighlightColor: 'transparent',
    };

    return (
        <div style={{
            display: 'flex', alignItems: 'stretch',
            minHeight: 56, borderRadius: 16, overflow: 'hidden',
            transition: 'background 0.25s, color 0.25s',
            ...vzhled,
        }}>
            <button type="button" onClick={onClick || undefined} disabled={muted}
                style={{ ...text, flex: secondary ? 2.4 : 1, gap: 8, padding: '0 14px', fontSize: tichy && !muted ? 15 : 17, fontWeight: tichy && !muted ? 700 : 800 }}>
                {!busy && icon}
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {busy ? (busyLabel || 'Pracuji…') : label}
                </span>
            </button>

            {secondary && (
                <button type="button" onClick={secondary.onClick} disabled={muted}
                    title={secondary.title || secondary.label}
                    style={{
                        ...text, flex: 1, gap: 6, padding: '0 10px',
                        fontSize: 14, fontWeight: 700,
                        background: muted || tichy ? 'transparent' : 'rgba(0,0,0,0.14)',
                        borderLeft: `1px solid ${muted || tichy ? 'var(--border-default)' : 'rgba(0,0,0,0.18)'}`,
                    }}>
                    {secondary.icon}
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{secondary.label}</span>
                </button>
            )}
        </div>
    );
}
